import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FaqService } from '../../services/faq.service';
import { FaqInterface } from '../../interfaces/faq.interface';

@Component({
  selector: 'app-faq-item',
  templateUrl: './faq-item.component.html',
  styleUrls: ['./faq-item.component.scss']
})
export class FaqItemComponent {
  @Input() listId: number;
  @Input() faq: FaqInterface;
  private registeredAccess: boolean;
  private copiedShareLink: boolean;

  constructor(private faqService: FaqService, private toastrService: ToastrService) {}

  public handleClick() {
    if (!this.registeredAccess) {
      this.registeredAccess = true;

      this.faqService.registerFaqAccess(this.faq.id);
    }
  }

  public async handleShareButtonClick() {
    if (!this.copiedShareLink) {
      await navigator.clipboard.writeText(this.faq.url);

      this.copiedShareLink = true;

      this.toastrService.success('Link copiado!');

      setTimeout(() => {
        this.copiedShareLink = false;
      }, 2000);
    }
  }
}
